import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageDetail, pathify } from '../../models/cms-models';
import { TagSelectorComponent } from '../tag-selector/tag-selector';

@Component({
  selector: 'cms-landing-page-metadata-form',
  imports: [CommonModule, FormsModule, TagSelectorComponent],
  templateUrl: './landing-page-metadata-form.html',
  styleUrl: './landing-page-metadata-form.css',
})
export class LandingPageMetadataFormComponent {
  @Input({ required: true }) landingPage!: LandingPageDetail;
  @Input() hideHeader = false;
  @Input() tagSuggestions: string[] = [];
  @Output() landingPageChange = new EventEmitter<LandingPageDetail>();

  update<K extends keyof LandingPageDetail>(key: K, value: LandingPageDetail[K]): void {
    this.landingPageChange.emit({
      ...this.landingPage,
      [key]: value,
    });
  }

  updateMetadata<K extends keyof LandingPageDetail['metadata']>(key: K, value: LandingPageDetail['metadata'][K]): void {
    this.landingPageChange.emit({
      ...this.landingPage,
      summary: key === 'summary' ? (value as string) : this.landingPage.summary,
      metadata: {
        ...this.landingPage.metadata,
        [key]: value,
      },
    });
  }

  syncPath(): void {
    this.update('path', pathify(this.landingPage.title));
  }

  updateTags(tags: string[]): void {
    this.update('tags', tags);
  }
}
